import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

import { computed } from "vue";

interface Props {
  name: string;
  width?: number | string;
  height?: number | string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DrawSvg',
  props: {
    name: {},
    width: {},
    height: {}
  },
  setup(__props: any) {

const props = __props;
const iconPath = computed(() => `/images/sprite.svg#${props.name}`);
const styleWidth = computed(() => (props.width ? `${props.width}px` : ""));
const styleHeight = computed(() => (props.height ? `${props.height}px` : ""));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    style: _normalizeStyle({ minWidth: styleWidth.value, width: styleWidth.value, height: styleHeight.value }),
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("use", {
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xlink:href": iconPath.value
    }, null, 8, _hoisted_1)
  ], 4))
}
}

})